import { NOT_FOUND } from 'redux-first-router';
import { useLanguageURLRoots } from '../config';

export const pageComponents = {
	start: 'Page/Page',
	page: 'Page/Page',
	404: 'Page/Page',
	search: 'Search/Search',
	product: 'Product/Product',
	category: 'Category/Category',
	selection: 'Selection/Selection',
	account: 'Account/Account',
};

export const getCurrentPath = (setup, pathname, type) => {
	const path = decodeURIComponent(pathname);
	let currentPath = path.indexOf('#') !== -1 ? path.slice(0, path.indexOf('#')) : path;
	currentPath = Object.keys(setup.languages).length > 1 && !useLanguageURLRoots ? currentPath.replace(/^\/[a-z]{2}\/?/, '') : currentPath.replace(/^\//, '');
	if (currentPath === '') currentPath = 'start';
	if (type === NOT_FOUND) currentPath = '404';
	currentPath = currentPath.replace(/\/+$/, '');

	return currentPath;
};

// Mirrors Switcher.jsx's Page component's page-resolution logic, so the server
// can preload the same async chunk it's about to render (see server/render.js).
export const resolvePage = ({ pageStatus, location, pageData, environment }) => {
	const currentPath = getCurrentPath(environment.setup, location.pathname, location.type);
	const data = location.type === NOT_FOUND ? null : pageData[currentPath];
	const page = location.type === 'START' ? 'start' : (data?.pageType || pageStatus?.pageType);

	return pageComponents[page];
};
